import React from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import { RootState } from 'app/store/types';
import { Button } from 'app/components/Button';
import { getFormValues } from 'redux-form';
import { FieldNames } from 'app/models/fields/names';
import { getFormType } from 'app/routes/helpers';
import { documentUploaderSelector } from 'app/reducers/app-config';
import { FormType } from '@lenderful/domain';
import { getLoanOfficer } from 'app/reducers/loan-officer';
import { OpenInNew } from '@material-ui/icons';

type MappedProps = ReturnType<typeof mapStateToProps>;
type DocumentUploadButtonProps = MappedProps;

const DocumentUploadButtonComponent = (props: DocumentUploadButtonProps) => {
  const { documentUploader, formName, loanOfficer, values } = props;

  if (!documentUploader) {
    return null;
  }

  const url = new URL(documentUploader.url);
  const urlSearchParams = url.searchParams;
  if (formName.startsWith('sb')) {
    urlSearchParams.append('name', values[FieldNames.commercialBusinessName]);
    urlSearchParams.append('phone', values[FieldNames.commercialPhone]);
  } else {
    urlSearchParams.append('name', `${values[FieldNames.firstName]} ${values[FieldNames.lastName]}`);
    urlSearchParams.append('phone', values[FieldNames.phone]);
    urlSearchParams.append('email', values[FieldNames.email]);
  }
  if (formName === FormType.REVERSE && loanOfficer.email) {
    urlSearchParams.append('n', loanOfficer.email.split('@')[0]);
  }
  url.search = urlSearchParams.toString();

  return (
    <Button
      classes  = {{ root: 'longButton' }}
      color    = 'primary'
      variant  = 'contained'
      rel      = 'noopener noreferrer'
      target   = '_blank'
      href     = {url.href}
      endIcon = {<OpenInNew />}
    >
      <Trans i18nKey='upload.documents.button'>
        Upload Documents
      </Trans>
    </Button>
  );
};

const mapStateToProps = (state: RootState) => ({
  documentUploader : documentUploaderSelector(state),
  formName         : getFormType(state.router.location.pathname),
  values           : getFormValues(getFormType(state.router.location.pathname))(state),
  loanOfficer      : getLoanOfficer(state),
});

export const DocumentUploadButton = connect(mapStateToProps)(DocumentUploadButtonComponent);
